<script lang="ts" setup>
import { computed } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import {
  AFFILIATE_REFERENCE_CONDITION_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_REFERENCE,
} from '@modules/affiliate-reference/constants';
import { useAffiliateReferenceQuery } from '@modules/affiliate-reference/queries';
import { useCopyToClipboard } from '@modules/core/composables/copy';
import VFormTextarea from '@modules/forms/components/inputs/VFormTextarea/VFormTextarea.vue';

const { data, isLoading } = useAffiliateReferenceQuery();
const { copyToClipboard } = useCopyToClipboard();

const inputValue = computed<string>(() => (`${window.location.origin}/affiliate_ref/${data.value?.token}`));

function copyLink(): void {
  void copyToClipboard(inputValue.value);
}
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateReferencePage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_AFFILIATE_REFERENCE, 'HEADER')"
  >
    <VLoader
      :loading="isLoading"
      mode="overlay"
    >
      <div>
        <VFormTextarea
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_REFERENCE, 'LINK')"
          :value="inputValue"
          hide-errors
          readonly
        />
        <div class="mt-6 flex gap-2">
          <VButton
            :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_REFERENCE, 'COPY')"
            @click="copyLink"
          />
          <VButton
            :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_REFERENCE, 'SHOW_CONDITION_BTN')"
            :to="{ name: AFFILIATE_REFERENCE_CONDITION_ROUTE_NAME }"
          />
        </div>
      </div>
    </VLoader>
  </VCard>
</template>
